import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { getAuthInfo } from '@/awsCodes/awsUtils';
import { IError } from '../interfaces/IError';
import { customAxiosInstance } from '../axios/axiosInstance';
import { IDeleteBusinessRepository } from '../interfaces/IDeleteBusinessRepository';
import { DeleteAllBusinessResponseAllOfResult, DeleteBusinessApi, ErrorResponseBody } from '../axios/generated/deleteBusinessManage/api';
import { axiosErrorHandler } from '../axios/axiosError';

/**
 * 独自エラークラス
 */
class ExampleError extends Error {
  /**
   * コンストラクタ
   * @param number - エラー番号
   */
  constructor(number: string) {
    super(`Example API : 想定外のコード${number}が返却されました。`);
    this.name = 'ExampleError';
  }
}

/**
 * Axiosを使ったリポジトリ実装例
 */
export class DeleteBusinessRepository implements IDeleteBusinessRepository {
  /**
   * idTokenで引ける組織IDを持つ取引情報を全て削除する
   * @param useInitData - 初期データを流し込むかどうか
   */
  async deleteAllBusiness(useInitData: boolean): Promise<INetworkResult<DeleteAllBusinessResponseAllOfResult, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const deleteBusinessApi = new DeleteBusinessApi(undefined, undefined, axiosInstance);

    // トークンの取得
    let idToken: string | undefined;
    if (true) {
      const res: any = await getAuthInfo();
      if (!res) throw new Error('refreshToken expired');
      idToken = res.idToken;
    }

    // トークンが取得できなかったらエラーにする
    if (!idToken) throw Error;

    // APIを叩く

    try {
      const apiResponse = await deleteBusinessApi.deleteAllBusiness(useInitData);
      switch (apiResponse.status) {
        case 200:
          const result: DeleteAllBusinessResponseAllOfResult = apiResponse.data['result'];
          // return { status: { type: 'success', result: orderId } };
          return { status: { type: 'success', data: result } };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }
}
